import styled, { css } from 'styled-components';
import { mobile_s, mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

interface Props {
  isMessagesLoading?: boolean;
  isWidth?: boolean;
  isProjectMessageDetail?: boolean;
}

const Main = styled.div<Props>`
  max-width: 715px;
  width: 100%;
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }
  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  ${(props) =>
    props.isMessagesLoading &&
    css`
      padding-bottom: var(--space-20);
    `}
  ${(props) =>
    props.isProjectMessageDetail &&
    css`
      padding-bottom: var(--space-80);
    `}
`;
const TopBorder = styled.div`
  width: 100%;
  display: block;
  border-bottom: 0.5px solid var(--background-muted);
  text-align: center;
  max-width: 271px;
  width: 100%;
`;
const Center = styled.div`
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
  max-width: 140px;
  height: 8px;
  width: 100%;
`;
const Border = styled.div<Props>`
  ${AlignCenter}
  gap: var(--space-16);
  margin-bottom: var(--space-24);
  ${mobile_xl(css<Props>`
    ${(props) =>
      props.isMessagesLoading &&
      css`
        margin: var(--space-0) var(--space-16) var(--space-20);
      `}
  `)}
`;

const Description = styled.div<Props>`
  display: flex;
  gap: var(--space-20);
  flex-direction: column;
  ${mobile_xl(css<Props>`
    width: calc(100vw - 32px);
    ${(props) =>
      props.isMessagesLoading &&
      css`
        align-items: center;
      `}
  `)}
`;
const First = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
`;
const Left = styled.div<Props>`
  width: 42px;
  height: 42px;
  background: var(--background-muted);
  border-radius: var(--border-radius-full);
  ${(props) =>
    props.isMessagesLoading &&
    css`
      width: 36px;
      height: 36px;
    `}
`;
const Circle = styled.div<Props>`
  width: 42px;
  height: 42px;
  ${(props) =>
    props.isMessagesLoading &&
    css`
      width: 36px;
      height: 36px;
    `}
`;
const Right = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  ${(props) =>
    props.isMessagesLoading &&
    css`
      gap: var(--space-12);
    `}
  ${(props) =>
    props.isWidth &&
    css`
      gap: var(--space-8);
    `}
`;
const Top = styled.div`
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
  width: 78px;
  height: 12px;
`;
const Bottom = styled.div<Props>`
  width: 372px;
  height: 12px;
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
  ${mobile_xl(css<Props>`
    width: 287px;
  `)}
  ${mobile_s(css<Props>`
    width: 268px;
  `)}
  ${(props) =>
    props.isMessagesLoading &&
    css`
      height: 6px;
    `}
  ${(props) =>
    props.isWidth &&
    css`
      height: 6px;
      width: 143px;
    `}
`;
const Middle = styled.div<Props>`
  width: 143px;
  height: 12px;
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
  ${mobile_xl(css<Props>`
    width: 287px;
  `)}
  ${mobile_s(css<Props>`
    width: 268px;
  `)}
  ${(props) =>
    props.isMessagesLoading &&
    css`
      width: 372px;
      height: 6px;
    `}
`;
const TopThird = styled.div`
  width: 96px;
  height: 12px;
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
`;
const MiddleThird = styled.div<Props>`
  width: 591px;
  height: 12px;
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
  ${mobile_xl(css<Props>`
    width: 287px;
  `)}
  ${mobile_s(css<Props>`
    width: 268px;
  `)}
  ${(props) =>
    props.isMessagesLoading &&
    css`
      width: 475px;
      height: 6px;
    `}
`;
const BottomThird = styled.div<Props>`
  width: 657px;
  height: 12px;
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
  ${mobile_xl(css<Props>`
    width: 287px;
  `)}
  ${mobile_s(css<Props>`
    width: 268px;
  `)}
  ${(props) =>
    props.isMessagesLoading &&
    css`
      width: 661px;
      height: 6px;
    `}
`;
const Third = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  padding-bottom: var(--space-36);
`;
const Footer = styled.div<Props>`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  box-shadow: var(--shadow-card);
  position: relative;
  ${FlexBetween}
  padding: var(--space-8) var(--space-8) var(--space-8) var(--space-12);
  max-width: 694px;
  width: 100%;
  min-height: 30px;
  position: fixed;
  bottom: 24px;
  ${mobile_xl(css<Props>`
    width: -webkit-fill-available;
    padding: var(--space-6) var(--space-16) var(--space-6) var(--space-20);
    margin: var(--space-0) var(--space-16) var(--space-0);
    bottom: 20px;
    ${(props) =>
      props.isProjectMessageDetail &&
      css`
        margin: var(--space-0) var(--space-16) var(--space-0) var(--space-0);
      `}
  `)}
`;
const LeftDiv = styled.div`
  width: 262px;
  height: 12px;
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
  ${mobile_xl(css`
    width: 175px;
  `)}
`;
const RightDiv = styled.div`
  position: absolute;
  display: flex;
  gap: var(--space-4);
  right: 8px;
  bottom: 8px;
  .svg {
    padding: var(--space-6);
    fill: var(--text-secondary);
  }
  .fill-color {
    stroke: var(--text-secondary);
  }
`;

export {
  Main,
  TopBorder,
  Center,
  Border,
  Description,
  First,
  Left,
  Right,
  Top,
  Bottom,
  Middle,
  TopThird,
  MiddleThird,
  BottomThird,
  Third,
  Footer,
  LeftDiv,
  RightDiv,
  Circle
};
